import { useMemo } from 'react';

type EncumbranceStatusProps = {
    currentWeight: number;
    maxWeight?: number;
};

function EncumbranceStatus({
    currentWeight,
    maxWeight
}: EncumbranceStatusProps) {
    const encumbranceStatus = useMemo(() => {
        if (maxWeight === undefined || maxWeight <= 0) {
            return null;
        }

        const encumberedThreshold = maxWeight / 3;
        const heavilyEncumberedThreshold = (maxWeight * 2) / 3;

        if (currentWeight > maxWeight) {
            return {
                label: 'Over Capacity',
                className: 'text-bg-danger',
            };
        }

        if (currentWeight > heavilyEncumberedThreshold) {
            return {
                label: 'Heavily Encumbered',
                className: 'text-bg-warning',
            };
        }

        if (currentWeight > encumberedThreshold) {
            return {
                label: 'Encumbered',
                className: 'text-bg-secondary',
            };
        }

        return null;
    }, [currentWeight, maxWeight]);

    return (
        <>
            {encumbranceStatus && (
                <span
                    className={
                        `badge rounded-pill ` +
                        encumbranceStatus.className
                    }
                >
                    {encumbranceStatus.label}
                </span>
            )}
        </>
    )
};

export default EncumbranceStatus;